import React from 'react'
import {
  Box,
  Color,
  Display,
  FlexDirection,
  Heading2,
  JustifyContent,
  TextAlign,
  Image,
  Body2,
  Bold,
} from '@gousto-internal/citrus-react'

import { FOOD_BOX_TYPES } from './config'
import { TargetUri, FoodBoxPageSections, TrackingActions } from '../../../../types/tracking'
import { LandingPageButton } from '../../../../components'
import { Carousel } from './Carousel'

export type FoodBox = {
  id: string
  title: string
  subtitle: string
  image: string
  alt: string
  target: TargetUri
  ctaText: string
  sectionName: FoodBoxPageSections
  action: TrackingActions
}

type FoodBoxCarouselProps = {
  boxes?: FoodBox[]
  startOnboarding: (target: TargetUri) => void
}

const FoodBoxCard = ({
  box,
  startOnboarding,
}: {
  box: FoodBox
  startOnboarding: (target: TargetUri) => void
}) => {
  return (
    <Box paddingH={[0, 2]} paddingBottom={[4, 0]} height="100%">
      <Box
        paddingH={3}
        paddingV={3}
        width={['100%', '220px']}
        height="100%"
        display={Display.Flex}
        flexDirection={FlexDirection.Column}
        bg={Color.White}
        style={{
          borderRadius: '4px',
        }}
      >
        <Image
          style={{ borderRadius: '4px' }}
          height={['170px', '170px']}
          width={['100%', '100%']}
          fit="cover"
          src={box.image}
          alt={box.alt}
        />

        <Box
          paddingH={2}
          paddingV={2}
          flexGrow={1}
          display={Display.Flex}
          flexDirection={FlexDirection.Column}
          justifyContent={JustifyContent.SpaceBetween}
        >
          <Box>
            <Box paddingBottom={1}>
              <Body2 size={4}>
                <Bold>{box.title}</Bold>
              </Body2>
            </Box>
            <Body2 size={4} color={Color.ColdGrey_700}>
              {box.subtitle}
            </Body2>
          </Box>

          <Box paddingV={2}>
            <LandingPageButton
              asLink
              startOnboarding={startOnboarding}
              sectionName={box.sectionName}
              target={box.target}
              action={box.action}
            >
              <Body2 size={2} color={Color.Secondary_400}>
                <Bold>{box.ctaText}</Bold>
              </Body2>
            </LandingPageButton>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export const FoodBoxCarousel = ({
  boxes = FOOD_BOX_TYPES.categories,
  startOnboarding,
}: FoodBoxCarouselProps) => (
  <Box paddingV={8} bg={Color.NeutralGrey_50}>
    <Box maxWidth="1200px" paddingH={[4, 6]} style={{ margin: '0 auto' }}>
      <Box paddingBottom={6}>
        <Heading2 textAlign={[TextAlign.Left, TextAlign.Center, TextAlign.Center]}>
          {FOOD_BOX_TYPES.heading}
        </Heading2>
      </Box>

      <Box display={[Display.Block, Display.None]}>
        {boxes.map((box) => (
          <FoodBoxCard key={box.id} box={box} startOnboarding={startOnboarding} />
        ))}
      </Box>
      <Box display={[Display.None, Display.Flex]} justifyContent={JustifyContent.Center}>
        <Carousel carouselAreaLabel="Food box options" options={{ loop: true }}>
          {boxes.map((box) => (
            <FoodBoxCard key={box.id} box={box} startOnboarding={startOnboarding} />
          ))}
        </Carousel>
      </Box>
    </Box>
  </Box>
)
